export function getCurrencySymbol(isoCode, currencyCode) {
  const currency_symbol = new Intl.NumberFormat(isoCode, {
    style: "currency",
    currency: currencyCode,
  }).formatToParts()[0].value;

  return currency_symbol;
}
export function getCurrencySymbolWithoutISO(currencyCode) {
  const COUNTRY_CODE = process.env.GATSBY_LOCALE_COUNTRY;

  const currency_symbol = new Intl.NumberFormat(`en-${COUNTRY_CODE}`, {
    style: "currency",
    currency: currencyCode,
  }).formatToParts()[0].value;

  return currency_symbol;
}
